import { observable, action, runInAction} from 'mobx'
import { json } from '../../../../../utils/ajax'

class PrintStore {
  // 数据
  @observable content

  constructor () {
    this.content = []
  }

  /**
   *打印内容
   */
  @action getPrint = async(directoryId) =>{
    const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/wxsc/content/searchOne?id=${directoryId}`)
    runInAction(()=>{
      this.content = res
    })
  }
}

export default new PrintStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/web/maintain/PrintContent/store.js